import cn from 'classnames'

import RowLayout, { /* Header, */HeaderContent, RowLayoutContent, Space } from 'app/common/layouts/RowLayout'
import CSSSticky from 'app/common/ui-components/css-sticky'
import Stub from 'app/common/layouts/Stub'
import { useProcessGenerate, DefaultProgressModal } from 'app/common/ui-components/progress-indicator'

import OrgOrdersOrProductionTabs, { ordersSections } from '../OrgOrdersOrProductionTabs'
import FilterWindow from './filter/FilterWindow'
import useFilterParams from './useFilterParams'
import useOOPGenerateRequests from './useOOPGenerateRequests'
import useOOPGenerateItems from './useOOPGenerateItems'
import { OOPByComplexes } from './results/OOPByComplexes'
import { OOPByClasses } from './results/OOPByClasses'

import styles from './OrgsOrdersProductionMain.scss'


type Props = {
  orgId: number,
  foodModeEnable: boolean,
  baseUrl: string,
}

const OrgsOrdersProductionMain = ({ orgId, foodModeEnable, baseUrl }: Props) => {
  const filterParams = useFilterParams(foodModeEnable, orgId)
  const generateRequests = useOOPGenerateRequests(filterParams)

  const [{
    generatedReportId,
    progress,
    processStatus,
  }, { onCancel }] = useProcessGenerate({ ready: filterParams, ...generateRequests })

  const { data, loading } = useOOPGenerateItems(generatedReportId)
  const asComplexes = filterParams?.details_group === 'by_complexes'
  const asClasses = filterParams?.details_group === 'by_klasses'


  const reportFileName = (filterParams
    ? `orders_productions_${filterParams.from}-${filterParams.to}`
    : 'orders_productions')


  return (
    <>
      <RowLayout paddingfree>

        <CSSSticky
          number={3}
          className={styles.stickable}
          shadowClassName={styles.shadow}
          stickyClassName={styles.sticky}
        >
          <HeaderContent
            paddingfree
            className={cn(styles.headerContent, styles.topBorderOnSticky)}
          >
            <OrgOrdersOrProductionTabs
              className={styles.headerContentTabs}
              baseUrl={baseUrl}
              type={ordersSections.PRODUCTION}
            />
            {/* <Header>{'Заявки'}</Header> */}
          </HeaderContent>
        </CSSSticky>

        {/* Окно с фильтром */}
        <RowLayoutContent borderTop>
          <FilterWindow
            foodModeEnable={foodModeEnable}
            loading={loading || processStatus !== 'hidden'}
          />
        </RowLayoutContent>
      </RowLayout>

      <Space />

      {/* Таблица с данными или заглушка */}
      <RowLayout paddingfree>
        {generatedReportId
          && asComplexes
          && <OOPByComplexes
            items={data.purchases}
            loading={loading}
            reportId={generatedReportId}
            reportFileName={reportFileName}
          />}

        {generatedReportId
          && asClasses
          && <OOPByClasses
            data={data}
            loading={loading}
            reportId={generatedReportId}
            reportFileName={reportFileName}
          />}

        {!generatedReportId && <Stub />}
      </RowLayout>

      {processStatus !== 'hidden'
        && <DefaultProgressModal
          progress={progress}
          isError={processStatus === 'error'}
          onCancel={onCancel}
        />}

    </>
  )
}

export default OrgsOrdersProductionMain
